import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../services/api";
import { IoSettings } from "react-icons/io5";
import { FaUniversity, FaFileInvoiceDollar, FaHeartbeat, FaPiggyBank } from "react-icons/fa";
import "./BusinessPage.css";




const BusinessPage = () => { 
  const { id } = useParams(); 
  const navigate = useNavigate();

  const [business, setBusiness] = useState(null);
  const [bankInfoExists, setBankInfoExists] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [taxStatus, setTaxStatus] = useState({ noIssues: true, missingFields: {} });

  // Leave requests (full table here)
  const [leaveRequests, setLeaveRequests] = useState([]);
  const [tableLoading, setTableLoading] = useState(true);
  const [alert, setAlert] = useState({ message: "", type: "" });

  
  

  useEffect(() => {
    
    const fetchAll = async () => {
      try {
        setLoading(true);

        const [{ data: businessData }, { data: bankInfo }, { data: taxStatusData }, { data: leaveData }] =
          await Promise.all([
            api.get(`/businesses/${id}`),
            api.get(`/business/${id}/check-lite-bank-data`),
            api.get(`/tax-status-fetch/${id}`),
            api.get(`/business/${id}/leave-requests`),
          ]);

        setBusiness(businessData);
        setBankInfoExists(bankInfo.exists);
        setTaxStatus(taxStatusData);
        setLeaveRequests(Array.isArray(leaveData) ? leaveData : []);
      } catch (err) {
        console.error(err);
        setError("Failed to fetch data. Please try again later.");
      } finally {
        setLoading(false);
        setTableLoading(false);
      }
    };
    fetchAll();
  }, [id]);

  const handleLeaveAction = async (requestId, status) => {
    try {
      const resp = await api.post(`/leave-request/${requestId}/update`, { status });
      if (resp.status === 200) {
        setLeaveRequests(prev =>
          prev.map(req => (req.id === requestId ? { ...req, status, approved_at: new Date().toISOString() } : req))
        );
        setAlert({ message: `Leave request ${status.toLowerCase()} successfully.`, type: "success" });
      } else {
        setAlert({ message: "Failed to update leave request.", type: "danger" });
      }
    } catch {
      setAlert({ message: "Error updating leave request.", type: "danger" });
    }
  };

  

  if (loading) return <p className="page-loading">Loading business details...</p>;
  if (error) return <p className="error-message">{error}</p>;
  if (!business) return <p>Business not found.</p>;

  // pending count for a small line above table
 

  return (
    <div className="bp-wrap">
      

      

      <div className="bp-grid">
        {/* LEFT: Leave Requests (full table) */}
        <div className="bp-card">
          <div className="card-head">
            <h2>Leave Requests</h2>
            <button
                  className="iconish"
                  onClick={() => navigate(`/dashboard/business/${id}/leave-tracker`)}
                  title="Leave settings"
                >
                  <IoSettings />
                </button>
          </div>

          {alert.message && (
            <div className={`blr-alert ${alert.type === "success" ? "ok" : "err"}`}>
              <button className="blr-alert-close" onClick={() => setAlert({ message: "", type: "" })}>
                ×
              </button>
              {alert.message}
            </div>
          )}

                
                
          

          {tableLoading ? (
            <div className="blr-center"><div className="blr-spinner" /></div>
          ) : leaveRequests.length ? (
            <div className="leave-table-shell">
  <div className="leave-table-head">
    <table className="pw-table leave-table leave-table--head">
      <thead>
        <tr>
          <th className="show-none">Department</th>
          <th>Name</th>
          <th className="show-none">Leave Type</th>
          <th className="show-none">Requested Period</th>
          <th className="show-none">Request Type</th>
          <th className="show-none">Status</th>
          <th>Action</th>
        </tr>
      </thead>
    </table>
  </div>

  <div className="leave-table-body-scroll">
    <table className="pw-table leave-table leave-table--body">
      <tbody>
        {leaveRequests.map((r) => {
          const status = r.status || "";
          const statusClass =
            status === "Approved" ? "approved" : status === "Denied" ? "rejected" : "pending";

          return (
            <tr key={r.id}>
              <td className="show-none">{r.department_name}</td>
              <td>{r.first_name} {r.last_name}</td>
              <td className="show-none">{r.leave_type}</td>
              <td className="show-none">{new Date(r.start_date).toLocaleDateString()} - {new Date(r.end_date).toLocaleDateString()}</td>
              <td className="show-none">{r.request_type}</td>
              <td className="show-none"><span className={`badge ${statusClass}`}>{status}</span></td>
              <td className="manage-cell">
                {status === "Pending" ? (
                  <>
                    <button className="btn-primary" onClick={() => handleLeaveAction(r.id, "Approved")}>
                      Approve
                    </button>
                    <button className="btn-outline" onClick={() => handleLeaveAction(r.id, "Denied")}>
                      Deny
                    </button>
                  </>
                ) : (
                  <span className="muted">{status}</span>
                )}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
</div>
          ) : (
            <p className="muted blr-center">No leave requests available.</p>
          )}
        </div>

        {/* RIGHT: tiles */}
        <div className="tiles">
          <div className="tile">
            <div className="tile-icon"><FaUniversity /></div>
            <div className="tile-body">
              <div className="tile-title">Bank Information</div>
              <div className="tile-sub"></div>
            </div>
            <button className="user-pro-link" onClick={() => navigate(`/dashboard/business/${id}/edit-bank-info`)}>
              {bankInfoExists ? "Manage" : "Add"}
            </button>
          </div>

          <div className="tile">
            <div className="tile-icon"><FaFileInvoiceDollar /></div>
            <div className="tile-body">
              <div className="tile-title">Tax Information</div>
              <div className="tile-sub">{taxStatus.noIssues ? "Tax info is completed" : "Missing info"}</div>
            </div>
            <button className="user-pro-link" onClick={() => navigate(`/dashboard/business/${id}/tax-rates`)}>
              Update
            </button>
          </div>

          <div className="tile">
            <div className="tile-icon"><FaHeartbeat /></div>
            <div className="tile-body">
              <div className="tile-title">Insurance Policy</div>
              <div className="tile-sub"></div>
            </div>
            <button className="user-pro-link" onClick={() => navigate(`/dashboard/business/${id}/benefits-view`)}>
              View
            </button>
          </div>

          <div className="tile">
            <div className="tile-icon"><FaPiggyBank /></div>
            <div className="tile-body">
              <div className="tile-title">Profit/Loss Spot Check</div>
              
            </div>
            <button className="user-pro-link" onClick={() => navigate(`/dashboard/business/${id}/average-cogs`)}>
              View
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessPage;




// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import api from "../services/api";
// import { IoSettings } from "react-icons/io5";
// import { FaUniversity, FaFileInvoiceDollar, FaHeartbeat, FaPiggyBank } from "react-icons/fa";
// import "./BusinessPage.css";

// const BusinessPage = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();

//   const [business, setBusiness] = useState(null);
//   const [bankInfoExists, setBankInfoExists] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [taxStatus, setTaxStatus] = useState({ noIssues: true, missingFields: {} });

//   // NEW: store all leave requests for table view like the screenshots
//   const [leaveRequests, setLeaveRequests] = useState([]);
//   const [pendingLeaves, setPendingLeaves] = useState([]);

//   // THEME
//   const [theme, setTheme] = useState(() => localStorage.getItem("pw-theme") || "light");
//   useEffect(() => {
//     document.documentElement.setAttribute("data-theme", theme);
//     localStorage.setItem("pw-theme", theme);
//   }, [theme]);

//   useEffect(() => {
//     const fetchBusinessDetails = async () => {
//       try {
//         setLoading(true);

//         // Business
//         const { data: businessData } = await api.get(`/businesses/${id}`);
//         setBusiness(businessData);

//         // Bank Info
//         const { data: bankInfo } = await api.get(`/business/${id}/check-bank-data`);
//         setBankInfoExists(bankInfo.exists);

//         // Tax Status
//         const { data: taxStatusData } = await api.get(`/tax-status-fetch/${id}`);
//         setTaxStatus(taxStatusData);

//         // Leave Requests (all)
//         const { data: leaveData } = await api.get(`/business/${id}/leave-requests`);
//         setLeaveRequests(leaveData || []);
//         const pending = (leaveData || []).filter(r => r.status === "Pending");
//         setPendingLeaves(pending);
//       } catch (err) {
//         console.error("Error fetching business details:", err);
//         setError("Failed to fetch data. Please try again later.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchBusinessDetails();
//   }, [id]);

//   const toggleTheme = () => setTheme(prev => (prev === "dark" ? "light" : "dark"));

//   if (loading) return <p className="page-loading">Loading business details...</p>;
//   if (error) return <p className="error-message">{error}</p>;
//   if (!business) return <p>Business not found.</p>;

//   return (
//     <div className="bp-wrap">
//       {/* Top bar (page-local) */}
//       <div className="bp-top">
//         <h1 className="bp-title">Welcome back, {business?.owner_name || "Robert"}.</h1>

//         <button
//           type="button"
//           className="theme-toggle"
//           aria-label="Toggle theme"
//           onClick={toggleTheme}
//         >
//           {theme === "dark" ? "Light Mode" : "Dark Mode"}
//         </button>
//       </div>

//       {/* Status banner like the screenshots */}
//       <div className={`status-banner ${taxStatus.noIssues ? "ok" : "warn"}`}>
//         <div className="status-icon">{taxStatus.noIssues ? "✓" : "!"}</div>
//         <div className="status-copy">
//           <div className="status-head">
//             {taxStatus.noIssues
//               ? "Everything’s set! Your tax information is complete."
//               : "There are missing tax fields."}
//           </div>
//           <div className="status-sub">
//             {taxStatus.noIssues
//               ? "No further action required."
//               : "Please fill in the required information."}
//           </div>
//         </div>
//         {!taxStatus.noIssues && (
//           <button
//             type="button"
//             className="btn-primary subtle"
//             onClick={() => navigate(`/dashboard/business/${id}/detect`)}
//           >
//             Update
//           </button>
//         )}
//       </div>

//       {/* Content grid */}
//       <div className="bp-grid">
//         {/* Leave Requests card with table preview */}
//         <div className="card">
//           <div className="card-head">
//             <h2>Leave Requests</h2>
//           </div>

//           {leaveRequests.length === 0 ? (
//             <div className="empty-state">
//               <div>No leave requests.</div>
//               <div className="empty-actions">
//                 <button
//                   className="linkish"
//                   onClick={() => navigate(`/dashboard/business/${id}/leave-requests`)}
//                 >
//                   View Leave Requests
//                 </button>
//                 <button
//                   className="iconish"
//                   onClick={() => navigate(`/dashboard/business/${id}/leave-tracker`)}
//                   aria-label="Leave tracker settings"
//                   title="Leave tracker settings"
//                 >
//                   <IoSettings />
//                 </button>
//               </div>
//             </div>
//           ) : (
//             <>
//               <div className="leave-cta">
//                 {pendingLeaves.length > 0 ? (
//                   <>
//                     <strong>{pendingLeaves.length}</strong> pending leave
//                     {pendingLeaves.length > 1 ? "s" : ""}.
//                     <button
//                       className="linkish ml8"
//                       onClick={() => navigate(`/dashboard/business/${id}/leave-requests`)}
//                     >
//                       View Leave Requests
//                     </button>
//                     <button
//                       className="iconish"
//                       onClick={() => navigate(`/dashboard/business/${id}/leave-tracker`)}
//                       aria-label="Leave tracker settings"
//                       title="Leave tracker settings"
//                     >
//                       <IoSettings />
//                     </button>
//                   </>
//                 ) : (
//                   <>
//                     <span>No pending leave requests.</span>
//                     <button
//                       className="linkish ml8"
//                       onClick={() => navigate(`/dashboard/business/${id}/leave-requests`)}
//                     >
//                       View Leave Requests
//                     </button>
//                     <button
//                       className="iconish"
//                       onClick={() => navigate(`/dashboard/business/${id}/leave-tracker`)}
//                       aria-label="Leave tracker settings"
//                       title="Leave tracker settings"
//                     >
//                       <IoSettings />
//                     </button>
//                   </>
//                 )}
//               </div>

//               <div className="table-wrap">
//                 <table className="pw-table">
//                   <thead>
//                     <tr>
//                       <th>Name</th>
//                       <th>Leave Type</th>
//                       <th>Date Requested</th>
//                       <th>Duration</th>
//                       <th>Status</th>
//                       <th>Manage</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {leaveRequests.slice(0, 4).map((r, idx) => {
//                       const statusClass =
//                         r.status === "Approved"
//                           ? "approved"
//                           : r.status === "Rejected"
//                           ? "rejected"
//                           : "pending";
//                       return (
//                         <tr key={`${r.id || idx}`}>
//                           <td>
//                             <div className="usercell">
//                               <div className="avatar" aria-hidden />
//                               <span>{r.first_name} {r.last_name}</span>
//                             </div>
//                           </td>
//                           <td>{r.leave_type || "Annual Leave"}</td>
//                           <td>
//                             {r.start_date && r.end_date
//                               ? `${new Date(r.start_date).toLocaleDateString(undefined, {
//                                   month: "short",
//                                   day: "2-digit",
//                                 })} - ${new Date(r.end_date).toLocaleDateString(undefined, {
//                                   month: "short",
//                                   day: "2-digit",
//                                   year: "numeric",
//                                 })}`
//                               : r.requested_range || "—"}
//                           </td>
//                           <td>{r.duration || r.days ? `${r.days} days` : "—"}</td>
//                           <td>
//                             <span className={`badge ${statusClass}`}>{r.status}</span>
//                           </td>
//                           <td className="manage-cell">
//                             {r.status === "Pending" ? (
//                               <>
//                                 <button
//                                   className="btn-primary"
//                                   onClick={() =>
//                                     navigate(`/dashboard/business/${id}/leave-requests`)
//                                   }
//                                 >
//                                   Approve
//                                 </button>
//                                 <button
//                                   className="btn-outline"
//                                   onClick={() =>
//                                     navigate(`/dashboard/business/${id}/leave-requests`)
//                                   }
//                                 >
//                                   Reject
//                                 </button>
//                               </>
//                             ) : (
//                               <button
//                                 className="btn-outline"
//                                 onClick={() =>
//                                   navigate(`/dashboard/business/${id}/leave-requests`)
//                                 }
//                               >
//                                 Edit
//                               </button>
//                             )}
//                           </td>
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                 </table>
//               </div>
//             </>
//           )}
//         </div>

//         {/* Action tiles (Bank, Tax, Insurance, Retirement) */}
//         <div className="tiles">
//           <div className="tile">
//             <div className="tile-icon">
//               <FaUniversity />
//             </div>
//             <div className="tile-body">
//               <div className="tile-title">Bank Information</div>
//               <div className="tile-sub">Last updated Sep 20</div>
//             </div>
//             <button
//               className="btn-primary"
//               onClick={() => navigate(`/dashboard/business/${id}/edit-bank-info`)}
//             >
//               {bankInfoExists ? "Manage" : "Add"}
//             </button>
//           </div>

//           <div className="tile">
//             <div className="tile-icon">
//               <FaFileInvoiceDollar />
//             </div>
//             <div className="tile-body">
//               <div className="tile-title">Tax Information</div>
//               <div className="tile-sub">
//                 {taxStatus.noIssues ? "Tax info is completed" : "Missing info"}
//               </div>
//             </div>
//             <button
//               className="btn-primary"
//               onClick={() => navigate(`/dashboard/business/${id}/tax-rates`)}
//             >
//               Update
//             </button>
//           </div>

//           <div className="tile">
//             <div className="tile-icon">
//               <FaHeartbeat />
//             </div>
//             <div className="tile-body">
//               <div className="tile-title">Insurance Policy</div>
//               <div className="tile-sub"></div>
//             </div>
//             <button
//               className="btn-primary"
//               onClick={() => navigate(`/dashboard/business/${id}/benefits-view`)}
//             >
//               View
//             </button>
//           </div>

//           <div className="tile">
//             <div className="tile-icon">
//               <FaPiggyBank />
//             </div>
//             <div className="tile-body">
//               <div className="tile-title">401k / IRA</div>
//               <div className="tile-sub">Not Set Up</div>
//             </div>
//             <button
//               className="btn-primary"
//               onClick={() => navigate(`/dashboard/business/${id}/retirement-setup`)}
//             >
//               Set Up
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default BusinessPage;




// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import api from "../services/api";
// import { IoSettings } from "react-icons/io5";
// import { FaUniversity, FaFileInvoiceDollar, FaHeartbeat, FaPiggyBank } from "react-icons/fa";

// import "./BusinessPage.css";


// const BusinessPage = () => {
//     const { id } = useParams();
//     const navigate = useNavigate();

//     const [business, setBusiness] = useState(null);
//     const [bankInfoExists, setBankInfoExists] = useState(false);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [taxStatus, setTaxStatus] = useState({ noIssues: true, missingFields: {} });
//     const [pendingLeaves, setPendingLeaves] = useState([]);


//     useEffect(() => {
//         const fetchBusinessDetails = async () => {
//             try {
//                 setLoading(true);

//                 // Fetch business details
//                 const { data: businessData } = await api.get(`/businesses/${id}`);
//                 setBusiness(businessData);

//                 // Fetch bank info
//                 const { data: bankInfo } = await api.get(`/business/${id}/check-bank-data`);
//                 setBankInfoExists(bankInfo.exists);

//                 // Fetch tax status
//                 const { data: taxStatusData } = await api.get(`/tax-status-fetch/${id}`);
//                 setTaxStatus(taxStatusData);

//                 // Inside fetchBusinessDetails function
//                 const { data: leaveData } = await api.get(`/business/${id}/leave-requests`);
//                 const pending = leaveData.filter((req) => req.status === "Pending");
//                 setPendingLeaves(pending);


//             } catch (error) {
//                 console.error("Error fetching business details:", error);
//                 setError("Failed to fetch data. Please try again later.");
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchBusinessDetails();
//     }, [id]);

//     if (loading) return <p>Loading business details...</p>;
//     if (error) return <p className="error-message">{error}</p>;
//     if (!business) return <p>Business not found.</p>;

//     return (
//         <div className="bus-details">
            
            

//             <div className="bus-actions">

//             <div className="action-list">
//             <div>
//                         <div className="action-item" onClick={() => navigate(`/dashboard/business/${id}/edit-bank-info`)}>
//                             <FaUniversity className="action-icon-bus" />
//                             {bankInfoExists ? "Change Bank Account Info" : "Add Bank Account Info"}
//                         </div>
//                         <div className="action-item" onClick={() => navigate(`/dashboard/business/${id}/tax-rates`)}>
//                             <FaFileInvoiceDollar className="action-icon-bus" />
//                             Edit Tax Information
//                         </div>
//                         </div>
//                         <div>
//                         <div className="action-item" onClick={() => navigate(`/dashboard/business/${id}/benefits-view`)}>
//                             <FaHeartbeat className="action-icon-bus" />
//                             Insurance Policies
//                         </div>
//                         <div className="action-item" onClick={() => navigate(`/dashboard/business/${id}/retirement-setup`)}>
//                             <FaPiggyBank className="action-icon-bus" />
//                             401k, IRA Setup
//                         </div>
//                         </div>
//                         </div>


               
                
//             </div>

//                         <div className="leave-request-box">
//   <p>
//     {pendingLeaves.length > 0 ? (
//       <div>
//         <strong>{pendingLeaves.length}</strong> pending leave request{pendingLeaves.length > 1 ? "s" : ""}.{" "}
//         <span className="leave-link" onClick={() => navigate(`/dashboard/business/${id}/leave-requests`)}>
//           View Leave Requests
//         </span>
//          <span className="settings-icon" onClick={() => navigate(`/dashboard/business/${id}/leave-tracker`)}>
//                     <IoSettings/> 
//                 </span>
        
//       </div>
//     ) : (
//       <div className="no-pending">
//         <div>No pending leave requests.{" "} </div>
        
//         <span className="leave-link" onClick={() => navigate(`/dashboard/business/${id}/leave-requests`)}>
//           View Leave Requests
//         </span>
//         <span className="settings-icon" onClick={() => navigate(`/dashboard/business/${id}/leave-tracker`)}>
//                     <IoSettings/> 
//                 </span>
//       </div>
//     )}
//   </p>
// </div>




//             {taxStatus.noIssues ? (
//                 <p className="tax-status success">All tax information is up to date!</p>
//             ) : (
//                 <>
//                     <p className="tax-status error">There are missing tax fields. Please fill in the required information.</p>
//                     <span onClick={() => navigate(`/dashboard/business/${id}/detect`)} className="action-tag important">
//                         Update Tax Information
//                     </span>
//                 </>
//             )}

//             <div className="bus-info-container">
                
//             </div>
//         </div>
//     );
// };

// export default BusinessPage;





// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import api from "../services/api";
// import "./BusinessPage.css";

// const BusinessPage = () => {
//     const { id } = useParams();
//     const [business, setBusiness] = useState(null);
//     const [bankInfoExists, setBankInfoExists] = useState(false); // Store results from /tax-info-detected
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null); // Error state for data fetching
//     const navigate = useNavigate();
//     const [taxStatus, setTaxStatus] = useState({ noIssues: true, missingFields: {} }); // For tax status

//     useEffect(() => {
//         const fetchBusinessDetails = async () => {
//             try {
//                 setLoading(true);

//                 // Fetch business details
//                 const { data: businessData } = await api.get(`/businesses/${id}`);
//                 setBusiness(businessData);

//                 // Fetch bank info
//                 const { data: bankInfo } = await api.get(`/business/${id}/check-bank-data`);
//                 setBankInfoExists(bankInfo.exists);

//                 // Fetch tax status
//                 const { data: taxStatusData } = await api.get(`/tax-status-fetch/${id}}`);
//                 setTaxStatus(taxStatusData);

               

                
                
//             } catch (error) {
//                 console.error("Error fetching business details or detected results:", error);
//                 setError("Failed to fetch data. Please try again later.");
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchBusinessDetails();
//     }, [id]);

    

//     if (loading) return <p>Loading business details...</p>;
//     if (error) return <p style={{ color: "red" }}>{error}</p>;
//     if (!business) return <p>Business not found.</p>;

//     return (
//         <div className="bus-details">
//             <p>
//                 <strong>Business:</strong> {business.name} (ID: {id})
//             </p>

           

//             {bankInfoExists ? (
//                 <button className="change-bank-btn" onClick={() => navigate(`/dashboard/business/${id}/edit-bank-info`)}>
//                     Change Bank Account Info
//                 </button>
//             ) : (
//                 <button className="add-bank-btn" onClick={() => navigate(`/dashboard/business/${id}/add-bank-info`)}>
//                     Add Bank Account Info
//                 </button>
//             )}
//             <button className="add-vacation-btn" onClick={() => navigate(`/dashboard/business/${id}/leave-tracker`)}>
//                     Leave Tracker
//                 </button>
//                 <button className="add-vacation-btn" onClick={() => navigate(`/dashboard/business/${id}/leave-requests`)}>
//                     Leave Requests
//                 </button>
//                 <button className="add-vacation-btn" onClick={() => navigate(`/dashboard/business/${id}/tax-status`)}>
//                     Tax
//                 </button>
//                 <button className="add-vacation-btn" onClick={() => navigate(`/dashboard/business/${id}/detect`)}>
//                     Detect
//                 </button>
//                 <button className="add-vacation-btn" onClick={() => navigate(`/dashboard/business/${id}/tax-rates`)}>
//                     Edit
//                 </button>
//                 {/* Display tax status */}
    
//             {taxStatus.noIssues ? (
//                 <p style={{textAlign:'center', color:'green'}}>All tax information is up to date!</p>
                
//             ) : (
//                 <>
//                 <p style={{textAlign:'center', color:'red', margin:'20px'}}>There are missing tax fields. Please fill tax information.</p>
//                 <button className="tax-button" onClick={() => navigate(`/dashboard/business/${id}/detect`)}>
//             Tax Information
//         </button>
//         </>
//             )}
                


//             <div className="bus-info-container">

//            <div className="bus-payroll-info">
//            <label>Payroll Information</label>

//            </div>
//            <div className="bus-accounting-info">
//            <label>Accounting Information</label>

//            </div>
//            </div>

            
//         </div>
//     );
// };

// export default BusinessPage;



